import { simulate } from '../mock-utils'
import { contactFromStay } from './real'
import type { AyudaService, ConversationMessage, FaqItem } from './types'

/**
 * Mock de Ayuda (PantallaAyuda.dc.html, Servicios.dc.html history). Códigos:
 *  - `ayuda-sin-faq` → sin preguntas frecuentes · `conversacion-vacia` → sin mensajes
 *  - `error-ayuda`, `offline-ayuda`, `lento-ayuda`
 */
const FAQ: FaqItem[] = [
  { id: 'F-1', question: '¿Cuándo me devuelven la fianza?', answer: 'Queda liberada cuando revisamos el apartamento tras tu salida, normalmente el mismo día. Tu banco puede tardar hasta 7 días en reflejarlo.' },
  { id: 'F-2', question: '¿Puedo llegar después de las 22:00?', answer: 'Sí. Con la llave digital entras a cualquier hora. Si no tienes cerradura conectada, escríbenos por WhatsApp y te explicamos cómo recoger las llaves.' },
  { id: 'F-3', question: '¿Hay parking cerca?', answer: 'El parking público de Plaza Mayor está a 3 minutos a pie, abierto 24 horas. No se puede reservar desde aquí.' },
]

const PROPERTY = 'Apartamentos Centro Histórico'

const CONVERSATION: ConversationMessage[] = [
  { id: 'M-1', from: 'guest', author: null, channel: 'whatsapp', text: 'Hola, ¿el ático tiene cuna? Venimos con el bebé de una amiga un día.', sentAt: '2026-09-14T18:40:00+02:00' },
  { id: 'M-2', from: 'property', author: PROPERTY, channel: 'whatsapp', text: '¡Hola, Marta! Sí, gratis. La puedes añadir desde Extras y os la dejamos montada.', sentAt: '2026-09-14T18:52:00+02:00' },
  { id: 'M-3', from: 'property', author: PROPERTY, channel: 'email', text: 'Os hemos enviado el enlace de registro a Jorge. Si no le llega, decidnos.', sentAt: '2026-09-15T09:15:00+02:00' },
]

export const ayudaMock: AyudaService = {
  async getContact(stay, signal) {
    await simulate(stay.guestCode, 'ayuda', signal)
    return { ...contactFromStay(stay), email: stay.guestCode.includes('hotel') ? 'recepcion@miradordelpuerto.example' : 'hola@centrohistorico.example' }
  },
  async getFaq(stay, signal) {
    await simulate(stay.guestCode, 'ayuda', signal)
    return stay.guestCode.includes('ayuda-sin-faq') ? [] : FAQ
  },
  async getConversation(stay, signal) {
    await simulate(stay.guestCode, 'ayuda', signal)
    return stay.guestCode.includes('conversacion-vacia') ? [] : CONVERSATION
  },
}
